import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { ReduxAsyncConnect } from 'redux-connect';
import GlobalErrorBoundary from '../common/components/errors/GlobalErrorBoundary';
import reloadOnPropsChange from './utils/reloadOnPropsChange';

export default function Root({ numHotReloads, store, routes, baseProps }) {
  const props = {
    ...baseProps,
    store,
  };

  return (
    <Provider store={store}>
      <GlobalErrorBoundary localizations={props.localizations}>
        <Router keyLength={numHotReloads}>
          <ReduxAsyncConnect
            routes={routes}
            render={() => renderRoutes(routes, props)}
            reloadOnPropsChange={reloadOnPropsChange}
          />
        </Router>
      </GlobalErrorBoundary>
    </Provider>
  );
}

Root.propTypes = {
  numHotReloads: PropTypes.number.isRequired,
  baseProps: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
};
